import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { EnvelopeSimple, Lock, HardHat, ArrowRight } from '@phosphor-icons/react';

export default function LoginPage({ onSwitchToRegister }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    if (!result.success) setError(result.error);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1759389964108-1940ff61db0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjcmFmdHNtYW4lMjBidWlsZGluZyUyMHRyb3BpY2FsJTIwaXNsYW5kJTIwaG9tZXxlbnwwfHx8fDE3NzYxMzA5MjR8MA&ixlib=rb-4.1.0&q=85"
          alt="Villa tropicale Mayotte" className="object-cover w-full h-full" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#09090B] via-[#09090B]/50 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-[#8B5CF6] flex items-center justify-center">
              <HardHat size={24} weight="duotone" className="text-white" />
            </div>
            <span className="text-white font-bold text-xl" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Shanga Pro</span>
          </div>
          <p className="text-white/90 text-lg leading-relaxed" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
            Transformez vos chantiers en posts marketing qui attirent des clients.
          </p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6 sm:p-12 bg-[#09090B]">
        <div className="w-full max-w-md animate-fade-in-up">
          <div className="flex items-center gap-3 mb-8 lg:hidden">
            <div className="w-10 h-10 rounded-lg bg-[#8B5CF6] flex items-center justify-center">
              <HardHat size={24} weight="duotone" className="text-white" />
            </div>
            <span className="font-bold text-xl text-[#F4F4F5]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Shanga Pro</span>
          </div>
          <h1 className="text-3xl font-black tracking-tight mb-2 text-[#F4F4F5]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Connexion</h1>
          <p className="text-[#A1A1AA] mb-8">Accédez à votre générateur de posts</p>
          {error && (
            <div className="mb-4 p-3 bg-red-500/10 border border-red-500/30 rounded-lg text-red-400 text-sm" data-testid="login-error">{error}</div>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1.5 text-[#E4E4E7]">Email</label>
              <div className="relative">
                <EnvelopeSimple size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#71717A]" />
                <input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  className="w-full h-12 pl-10 pr-4 border border-[#27272A] rounded-lg bg-[#18181B] text-[#F4F4F5] focus:border-[#8B5CF6] focus:ring-1 focus:ring-[#8B5CF6] outline-none transition-all placeholder:text-[#71717A]"
                  placeholder="votre@email.com" required />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1.5 text-[#E4E4E7]">Mot de passe</label>
              <div className="relative">
                <Lock size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#71717A]" />
                <input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                  className="w-full h-12 pl-10 pr-4 border border-[#27272A] rounded-lg bg-[#18181B] text-[#F4F4F5] focus:border-[#8B5CF6] focus:ring-1 focus:ring-[#8B5CF6] outline-none transition-all placeholder:text-[#71717A]"
                  placeholder="Votre mot de passe" required />
              </div>
            </div>
            <button data-testid="login-submit-button" type="submit" disabled={loading}
              className="w-full h-12 bg-[#8B5CF6] text-white font-bold rounded-lg hover:bg-[#7C3AED] transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
              {loading ? 'Connexion...' : <>Se connecter <ArrowRight size={18} weight="bold" /></>}
            </button>
          </form>
          <p className="mt-6 text-center text-sm text-[#A1A1AA]">
            Pas encore de compte ?{' '}
            <button data-testid="switch-to-register" onClick={onSwitchToRegister} className="text-[#A78BFA] font-semibold hover:underline">Créer un compte</button>
          </p>
        </div>
      </div>
    </div>
  );
}
